var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 604 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 123.939,
    width: 575.704,
    height: 105.805,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5 197.1L75.3 185.3H75.5L83.2 197.1L90.3 191.9L81.5 180.9V180.7L95.2 177L92.5 168.6L79.1 173.6L79.9 159.4H70.8L71.5 173.6L58.2 168.6L55.6 177L69.2 180.7V180.9L60.3 191.9L67.5 197.1ZM124.18 197.1L131.98 185.3H132.18L139.88 197.1L146.98 191.9L138.18 180.9V180.7L151.88 177L149.18 168.6L135.78 173.6L136.58 159.4H127.48L128.18 173.6L114.88 168.6L112.28 177L125.88 180.7V180.9L116.98 191.9L124.18 197.1Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.5 197.1L455.3 185.3H455.5L463.2 197.1L470.3 191.9L461.5 180.9V180.7L475.2 177L472.5 168.6L459.1 173.6L459.9 159.4H450.8L451.5 173.6L438.2 168.6L435.6 177L449.2 180.7V180.9L440.3 191.9L447.5 197.1Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.964 87.0215C387.864 76.1502 385.675 65.3969 381.512 55.3482C377.251 45.0598 371.004 35.7116 363.13 27.8372C355.256 19.9629 345.907 13.7166 335.619 9.45498C325.331 5.19341 314.304 3 303.168 3C292.032 3 281.005 5.19341 270.716 9.45499C260.428 13.7166 251.08 19.9629 243.205 27.8372C235.331 35.7116 229.085 45.0598 224.823 55.3482C220.661 65.3969 218.471 76.1502 218.372 87.0215H218.368V157.04H252.599V87.0215H251.162C251.261 80.4562 252.601 73.9664 255.116 67.8958C257.729 61.5856 261.561 55.8519 266.39 51.0222C271.22 46.1925 276.954 42.3614 283.264 39.7476C289.574 37.1338 296.337 35.7885 303.168 35.7885C309.998 35.7885 316.761 37.1338 323.071 39.7476C329.382 42.3614 335.115 46.1925 339.945 51.0222C344.775 55.8519 348.606 61.5856 351.22 67.8958C353.734 73.9664 355.075 80.4562 355.173 87.0215H353.737V157.04H387.968V87.0215H387.964Z",
    fill: "#423D56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.291 83.9097C369.186 75.8992 367.46 67.9784 364.203 60.5726C360.841 52.9271 355.913 45.9802 349.7 40.1287C343.487 34.2771 336.111 29.6353 327.994 26.4685C319.876 23.3016 311.176 21.6716 302.39 21.6716C293.604 21.6716 284.904 23.3016 276.786 26.4685C268.669 29.6353 261.293 34.2771 255.08 40.1287C248.867 45.9803 243.939 52.9271 240.577 60.5726C237.32 67.9784 235.594 75.8992 235.489 83.9097H235.484V157.04H252.957V84.1421C253.031 78.2132 254.306 72.3503 256.717 66.8693C259.201 61.2201 262.843 56.0871 267.433 51.7634C272.024 47.4397 277.474 44.01 283.472 41.67C289.469 39.33 295.898 38.1256 302.39 38.1256C308.882 38.1256 315.311 39.33 321.309 41.67C327.306 44.01 332.756 47.4397 337.347 51.7634C341.937 56.0871 345.579 61.2201 348.063 66.8693C350.548 72.5185 351.826 78.5732 351.826 84.6878H351.839V157.04H369.312V83.9097H369.291Z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.647 100.509C194.363 100.509 187.647 107.225 187.647 115.509V248.117C187.646 248.186 187.646 248.255 187.646 248.325C187.646 248.394 187.646 248.464 187.647 248.533V252.328C187.647 257.851 192.125 262.328 197.647 262.328H197.664C215.791 273.964 256.476 281 302.786 281C349.1 281 388.94 273.963 406.621 262.325C412.029 262.194 416.373 257.768 416.373 252.328V115.509C416.373 107.225 409.657 100.509 401.373 100.509H202.647Z",
    fill: "#00BFF3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 187,
    y: 100,
    width: 230,
    height: 181
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.647 100.509C194.363 100.509 187.647 107.225 187.647 115.509V248.117C187.646 248.186 187.646 248.255 187.646 248.325C187.646 248.394 187.646 248.464 187.647 248.533V252.328C187.647 257.851 192.125 262.328 197.647 262.328H197.664C215.791 273.964 256.476 281 302.786 281C349.1 281 388.94 273.963 406.621 262.325C412.029 262.194 416.373 257.768 416.373 252.328V115.509C416.373 107.225 409.657 100.509 401.373 100.509H202.647Z",
    fill: "#FFCA28"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.787,
    y: 91.1731,
    width: 143.148,
    height: 199.162,
    fill: "#037DBA"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.764 188.663C322.911 184.288 327.68 176.408 327.68 167.415C327.68 153.666 316.534 142.52 302.784 142.52C289.035 142.52 277.889 153.666 277.889 167.415C277.889 176.062 282.298 183.679 288.989 188.142L284.324 236.798C284.211 237.973 285.135 238.989 286.315 238.989H317.73C318.899 238.989 319.819 237.99 319.723 236.825L315.764 188.663Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.702 83.4837L158.705 88.1516M147.036 55.4765L163.373 71.8141M175.821 52.3646L179.711 67.1462",
    stroke: "#01BFF3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.338 81.9279L447.335 86.5958M459.004 53.9207L442.667 70.2582M430.219 50.8088L426.329 65.5904",
    stroke: "#01BFF3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.68 197.846H537.579",
    stroke: "#3F3D56",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 603.704,
    height: 306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.a283437b.svg";
export { ForwardRef as ReactComponent };